import React from 'react';
import { Error404 } from '../../styles/pages/NotFound';

// import { Container } from './styles';

const NotFound: React.FC = () => {
  return (
     <Error404>
         <img src="/img/error404.svg" alt="" />
         <h1>PÁGINA NÃO ENCONTRADA</h1>
     </Error404>
  );
}

export default NotFound;